import { Skeleton } from "@ecco/ui/skeleton";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import { PRODUCT_CAROUSEL_DEFAULT_TILE_WIDTHS } from "@lib/constants/carousel";

const ProductCarouselSkeleton = ({
    height = ["auto", "100vw", "66vw", "48vw", "45vw"],
    width = PRODUCT_CAROUSEL_DEFAULT_TILE_WIDTHS,
}: {
    height?: string[];
    width?: string[];
}) => {
    return (
        <Box w="full" mt="0.2" py={3}>
            <Flex justifyContent={"space-between"} alignItems="center" px={[4, 4, 4, 6]}>
                <Skeleton height="14px" width={[28, 60]} />
            </Flex>
            <Flex direction="row" gap={0.2} mt={3} pb={3} h={height} overflowX={"scroll"}>
                {Array(4)
                    .fill("")
                    .map((_, index) => (
                        <Flex key={index} w="100%">
                            <Box width={"full"} w={width}>
                                <Skeleton mb={4} aspectRatio={["4/5"]} />
                                <Box px={5} py={3} gap={1}>
                                    <Skeleton height="21px" width={[28, 60]} mb={1} />
                                    <Skeleton height="21px" width={[20, 39]} mb={1} />
                                    <Skeleton height="21px" width={[10.4, 20]} />
                                </Box>
                            </Box>
                        </Flex>
                    ))}
            </Flex>
        </Box>
    );
};

export default ProductCarouselSkeleton;
